import { makeLazy } from "lib/make-lazy"

export const FacilityConfiguration = makeLazy(
    () => import("routes/schedule/my-schedules/my-group-types/facility/inner-facility-configuration"),
    "InnerFacilityConfiguration"
)
